import { clsx } from "clsx";
import type { ComponentPropsWithRef } from "react";

type Variant = "primary" | "secondary" | "ghost" | "danger" | "danger-secondary";

// Colour comes only from the variant: adding colour utilities via className would
// compete with these in CSS order (that is how a destructive button once rendered navy).
const VARIANTS: Record<Variant, string> = {
  primary: "bg-primary text-on-primary hover:bg-primary-hover",
  secondary: "bg-surface text-primary border border-border hover:bg-bg",
  ghost: "bg-transparent text-primary hover:bg-bg",
  /** Confirms a destructive action. */
  danger: "bg-danger text-on-primary hover:opacity-90",
  /** Starts a destructive action (asks for confirmation next). */
  "danger-secondary": "bg-surface text-danger border border-border hover:bg-danger-bg",
};

export interface ButtonProps extends ComponentPropsWithRef<"button"> {
  variant?: Variant;
}

export function Button({ variant = "primary", className, type = "button", ...props }: ButtonProps) {
  return (
    <button
      type={type}
      className={clsx(
        "inline-flex h-10 items-center justify-center gap-2 rounded-md px-4 text-sm font-semibold transition-colors",
        "disabled:cursor-not-allowed disabled:opacity-60",
        VARIANTS[variant],
        className,
      )}
      {...props}
    />
  );
}
